package com.upcominds.expedite.util

import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toInstant
import kotlinx.datetime.toLocalDateTime

fun parseBackendInstantOrNull(raw: String?): Instant? {
    if (raw.isNullOrBlank()) return null

    val normalized = raw.trim().replace(" ", "T")
    return runCatching { Instant.parse(normalized) }
        .recoverCatching {
            val withZone = if (normalized.endsWith("Z") || normalized.contains("+")) {
                normalized
            } else {
                // Backend sends UTC timestamps; assume UTC when zone suffix is missing.
                "${normalized}Z"
            }
            Instant.parse(withZone)
        }
        .recoverCatching {
            // Fallback for plain LocalDateTime strings like 2026-05-31T11:22[:ss[.n]].
            LocalDateTime.parse(normalized).toInstant(TimeZone.UTC)
        }
        .getOrNull()
}

fun String.toLocalDateTimeText(): String {
    val parsed = parseBackendInstantOrNull(this) ?: return this
    val local = parsed.toLocalDateTime(TimeZone.currentSystemDefault())

    val month = local.monthNumber.toString().padStart(2, '0')
    val day = local.dayOfMonth.toString().padStart(2, '0')
    val hour = local.hour.toString().padStart(2, '0')
    val minute = local.minute.toString().padStart(2, '0')

    return "${local.year}-$month-$day $hour:$minute"
}

fun String.toLocalDateText(): String {
    val parsed = parseBackendInstantOrNull(this) ?: return this
    val local = parsed.toLocalDateTime(TimeZone.currentSystemDefault()).date
    val year = (local.year % 100).toString().padStart(2, '0')
    val month = local.monthNumber.toString().padStart(2, '0')
    val day = local.dayOfMonth.toString().padStart(2, '0')
    return "$day/$month/$year"
}
